import moment from 'moment';

export default class DateFormat {
  public static splitTimestamp(date: string): string[] {
    return date.split('-');
  }

  public static splitLocal(date: string): string[] {
    return date.split('/');
  }

  public static splitTime(time: string): string[] {
    return time.split(':');
  }

  public static timestampToLocal(date: string): string {
    if (date && date.includes('-')) {
      const [year, month, day] = this.splitTimestamp(date);
      return `${day}/${month}/${year}`;
    }
    return date;
  }

  public static standardDate(date: string): string {
    if (!date) {
      return '';
    }
    const [year, month, day] = this.splitTimestamp(date);
    return `${day}/${month}/${year}`;
  }

  public static monthNumberYear(date: string): string {
    if (!date) {
      return '';
    }
    const [year, month] = this.splitTimestamp(date);
    return `${month}/${year}`;
  }

  public static timestampToSimpleLocal(date: string): string {
    if (date) {
      const [year, month, day] = this.splitTimestamp(date.substr(0, 10));
      return `${day}/${month}/${year}`;
    }
    return date;
  }

  public static fullDateAndTime(date: string): string {
    if (date.includes('-')) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    }
    return date;
  }

  public static localToTimestamp(date: string): string {
    if (date.includes('/')) {
      const [day, month, year] = this.splitLocal(date);
      return `${year}-${month}-${day}`;
    }
    return date;
  }

  public static localToDate(date: string): string {
    if (date.includes('/')) {
      const [month, year] = this.splitLocal(date);
      return `${year}-${month}`;
    }
    return date;
  }

  public static localDateToLocal(date: string): string {
    if (date) {
      const [year, month] = date.split('-');
      return `${month}/${year}`
    }
    return date
  }

  public static newMonthAndYear(): string {
    const date = new Date().toLocaleDateString();
    const [day, month, year] = this.splitLocal(date)
    return `${month}/${year}`
  }

  public static newfullDateAndTime(): string {
    const date: Date = new Date();
    const calendarDate: string = DateFormat.timestampToLocal(date.toISOString().substr(0, 10));
    const hours: string = date.getHours() < 10 ? `0${date.getHours()}` : `${date.getHours()}`;
    const minutes: string = date.getMinutes() < 10 ? `0${date.getMinutes()}` : `${date.getMinutes()}`;
    const time: string = `${hours}:${minutes}`;
    return `${calendarDate} ${time}`;
  }

  public static simpleMonthAndYear(value: string): string {
    return moment(value, 'YYYY-MM').format('MM/YYYY')
  }

  public static simpleDate(value: string): string {
    return moment(value).format('DD/MM/YYYY')
  }

  public static fullMonthAndYear(value: string): string {
    if (value) {
      let month = '';
      let year = '';
      if (value.includes('/')) {
        [month, year] = value.split('/');
      } else {
        [year, month] = value.split('-');
      }
      return `${this.fullMonth(month)}, ${year}`;
    }
    return value;
  }

  public static getFirstAndLastDayOfMonthByCompetence(competence: string): string[] {
    const competenceDate = moment(competence, 'YYYY-MM');
    return [competenceDate.startOf('month').format('DD/MM/YYYY'), competenceDate.endOf('month').format('DD/MM/YYYY')]
  }

  public static formatToIsoDate(date: string) {
    return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
  }

  public static fullMonth(monthNumber: string): string {
    switch (monthNumber) {
      case '01':
      case '1':
        return 'Janeiro';
      case '02':
      case '2':
        return 'Fevereiro';
      case '03':
      case '3':
        return 'Março';
      case '04':
      case '4':
        return 'Abril';
      case '05':
      case '5':
        return 'Maio';
      case '06':
      case '6':
        return 'Junho';
      case '07':
      case '7':
        return 'Julho';
      case '08':
      case '8':
        return 'Agosto';
      case '09':
      case '9':
        return 'Setembro';
      case '10':
        return 'Outubro';
      case '11':
        return 'Novembro';
      case '12':
        return 'Dezembro';
      default:
        return '';
    }
  }
}
